export function fr() {
	return {
		'form': {
			'from': 'De',
			'to': 'À',
			'username': 'Nom d’utilisateur',
			'password': 'Mot de passe',
			'type': 'Type',
			'status': 'Statut',
			'transactionPassword': 'Mot de passe de transaction',
			'confirmUsername': 'Confirmer nom d’utilisateur',
			'confirmPassword': 'Confirmer mot de passe',
			'confirmTransactionPassword': 'Confirmer le mot de passe de transaction',
			'paymentOption': 'Options de paiement',
			'fromProduct': 'Du produit',
			'email': 'E-mail',
			'website': 'Site internet',
			'promotion': 'Offre promotionnelle',
			'advertisement': 'Pub',
			'language': 'Langue',
			'size': 'Taille',
			'campaign': 'Nom de la campagne',
			'referralCode': 'Code de référencement',
			'newPassword': 'Nouveau mot de passe',
			'iban': 'Numéro de compte/IBAN',
			'accountName': 'Nom du compte / Nom de l’entreprise',
			'birthDate': 'Date de naissance',
			'citizenship': 'Nationalité',
			'address': 'Adresse',
			'swift': 'Code banque (BIC) / SWIFT',
			'bankName': 'Nom de la banque',
			'bankAddress': 'Adresse de la banque',
			'isDefault': 'Utilisé par défaut',
		},
		'titles': {
			'bankAccount': 'Compte bancaire',
			'dashboard': 'Tableau de bord',
			'account': 'Mon compte',
			'profile': 'Mon profil',
			'transaction': 'Transactions',
			'transactionHistory': 'Historique des transactions',
			'overview': 'Vue d’ensemble',
			'deposit': 'Dépôt',
			'withdrawal': 'Retrait',
			'transfer': 'Transfert',
			'productWallet': 'Transfert (à un autre bookmaker)',
			'p2pTransfer': 'Transfert (à une autre personne)',
			'skypeBetting': 'Skype Betting',
			'outstandingBets': 'Paris en cours',
			'betHistory': 'Historique de paris',
			'betOverview': 'Récapitulatif des paris',
			'affiliate': 'Affiliation',
			'affiliateDashboard': 'Tableau de bord affiliation',
			'affiliateTools': 'Outils d’affiliation',
			'supportTickets': 'Billets de soutien',
			'settings': 'Paramètres',
			'mobileSite': 'Site mobile AMS',
			'Valid Turnover/Commissions': 'Commissions / turnover validé',
			'products': 'Produits',
			'size': 'Taille',
			'campaign': 'Nom de la campagne',
			'referralCode': 'Code de référencement',
			'website': 'Site internet',
			'tickets': 'Billets de soutien',
		},
		'tables': {
			'product': 'Produit',
			'memberId': 'ID membre',
			'totalTurnover': 'Total turnover',
			'totalWinLoss': 'Total Customer W/L',
			'totalCommission': 'Commissions affilié',
			'date': 'Date',
			'transactionNumber': 'Transaction #',
			'type': 'Type',
			'language': 'Langue',
			'currency': 'Devise',
			'paymentOption': 'Option de paiement',
			'amount': 'Montant',
			'status': 'Statut',
			'Total Commission': 'Total commissions',
			'subject': 'Sujet',
			'description': 'La description',
			'username': 'Nom d’utilisateur',
			'balance': 'Balance',
			'dateLastUpdated': 'Date de dernière mise à jour'
		},
		'Reset password': 'Ré-initialiser mot de passe',
		'Activate Later': 'Activer plus tard',
		"You're on your way to earning a lifetime commission. Just follow 4 easy steps.": "Vous êtes sur le point de gagner une commission à vie. Suivez simplement ces 4 étapes",
		'I confirm that I have read and accepted': 'Je confirme avoir lu et accepté',
		'Asianconnect Affiliates Terms and Conditions': 'Les conditions générales d’Asianconnect affiliation',
		'Get Started': 'Commencer',
		'Banners and Referral Codes': 'Code de référencement et bannières',
		'Learn more': 'En savoir plus',
		'Archive': 'Archive',
		'generateBannerNote': 'Remplissez simplement le formulaire avec les détails de votre campagne et nous générerons pour vous un lien d’affiliation unique et une bannière téléchargeable',
		'Setup your username and password now': 'Choisissez votre nom d’utilisateur et votre mot de passe maintenant',
		'Welcome to AC Affiliates!': 'Bienvenue au sein du programme d’affiliation d’Asianconnect!',
		'Please enter your Campaign Name': 'Veuillez SVP entrer votre nom de campagne',
		'Please enter your Referral Code': 'Veuillez SVP entrer votre code de référencement souhaité',
		'Get code': 'Obtenez votre code',
		'Reset': 'Ré-initialisation',
		'Generate': 'Générer',
		'referralCodeNote': 'Vous pouvez ré-utiliser votre code URL existant or en créer un nouveau, les caractères spéciaux et les espaces ne sont pas autorisés.',
		'Special characters and spaces are not allowed.': 'Les caractères spéciaux et les espaces ne sont pas autorisés.',
		'See Preview': 'Voir Pré-visualisation',
		'Preview': 'Pré-visualisation',
		'Please enter your website URL': 'Veuillez SVP entrer l’URL de votre site internet',
		'Please contact Customer Support.': 'Veuillez SVP contacter le service client',
		'Change email': 'Changer email',
		'Transfer from': 'Transfert de',
		'Transfer to': 'Transfert à',
		'Product': 'Produit',
		'Please Select': 'Sélectionnez',
		'Commission Period': 'Période commissions',
		'Original Payout Date': 'Date de paiement',
		'to': 'à',
		'Reason': 'Raison',
		'commission': 'Commissions',
		'Search': 'Rechercher',
		'Reset Filter': 'Ré-initialiser filtre',
		'All Status': 'Tous les statuts',
		'Product Username': 'Nom d’utilisateur produit',
		'All Payment Options': 'Toutes les options de paiement',
		'All types': 'Tous types',
		'Sign In': 'Se connecter',
		'Sign in to start your session': 'Se connecter pour ouvrir une session',
		'Please wait, Logging in...': 'Attendez pendant la connexion SVP',
		'signOut': 'Se déconnecter',
		'memberSince': 'Membre depuis',
		'Note:': 'Note:',
		'Note': 'Note',
		'makeDeposit': 'Faîtes un dépôt pour augmenter vos fonds disponibles',
		'welcome': 'Bienvenue sur Asianconnect AMS!',
		'setup': 'Paramétrer votre nom d’utilisateur et votre mot de passe maintenant',
		'to activate your account.': 'Pour activer votre compte',
		'setupNote': 'Note : Votre nom d’utilisateur temporaire et votre mot de passe ont été envoyés sur votre adresse email',
		'Proceed': 'Proceed',
		'Deposit Now': 'Faîtes un dépôt maintenant',
		'Available Balance': 'Balance disponible',
		'Unallocated Balance': 'Balance non allouée',
		'Account Status': 'Statut du compte',
		'Quick Links': 'Liens rapides',
		'BETA': 'BETA',
		'Verified': 'Vérifié',
		'Not Verified': 'Non vérifié',
		'Filter': 'Filtre',
		'Request Transfer': 'Transfert requête',
		'loadingPageContent': 'Chargement de la page, merci de patienter',
		'Date Covered:': 'Date couverte:',
		'Total Turnover:': 'Total turnover:',
		'Total Affiliate Commission:': 'Total commissions affilié:',
		'Total Customer W/L:': 'Total client W/L:',
		'exportCsv': 'Exporter en format CSV',
		'noProduct': 'Pas de produit',
		'somethingWentWrong': 'Une erreur semble s’être produite. Veuillez SVP vérifier vos informations',
		'activated': 'Vous avez activé votre compte avec succès',
		'Account Activation': 'Activation de compte',
		'activateAccountNote': 'Activez votre compte en remplissant vos données ci-dessous',
		'usernameValidation': 'Doit contenir seulement des lettres, chiffres et underscore',
		'passwordValidation': 'Doit contenir au moins 8 caractères, dont 2 lettres, 2 chiffres et 2 symboles',
		'transactionPasswordValidation': 'Doit contenir au minimum 6 caractères alpha numériques, avec au moins une lettre majuscule',
		'Re-enter username': 'Entrez de nouveau votre nom d’utilisateur',
		'Re-enter password': 'Entrez de nouveau votre mot de passe',
		'Re-enter transaction password': 'Entrez de nouveau votre mot de passe de transaction',
		'Activate account': 'Activez votre compte',
		'Clear All': 'Tout supprimer',
		'skrillContent': 'Veuillez SVP vous connecter à votre compte SKRILL et transférer le montant souhaité à ',
		'netellerContent': 'Veuillez SVP vous connecter à votre compte NETELLER et transférer le montant souhaité à ',
		'verifyDeposit': 'Nous allons maintenant vérifier votre dépôt. Dès que nous aurons reçu votre dépôt, celui-ci apparaîtra sur votre compte ',
		'netellerTransferNote': 'Veuillez SVP vous connecter à votre compte NETELLER et transférer le montant souhaité à ',
		'netellerTransferNote2': 'Avec code de transfert de ',
		'you will see the additional funds reflected in your account.': 'Votre dépôt apparaîtra sur votre compte',
		'CONTINUE': 'Continuer',
		'cantProcessRequest': "Désolé, nous ne sommes pas en mesure de procéder à votre requête pour le moment",
		'Sorry': 'Désolé',
		'Thank you': 'Merci',
		'OK': 'OK',
		'For making a deposit': 'Pour effectuer un dépôt',
		'We are now verifying your deposit. Once we have received your deposit,': 'Nous allons maintenant vérifier votre dépôt. Dès que nous aurons reçu votre dépôt',
		'bankNotice': 'Les transactions bancaires ne sont pas possibles pour le moment. Pour toute demande, merci de contacter le service client. Merci',
		'bankRestricted': 'Les transactions bancaires sont restreintes pour votre pays. Veuillez SVP utiliser une autre méthode de paiement.',
		'processingTime': 'Temps de traitement',
		'fee': 'Frais',
		'minimumDeposit': 'Dépôt minimum',
		'maximumDeposit': 'Dépôt maximum',
		'chooseProductDeposit': 'Choisissez simplement votre bookmaker préféré, entrez le montant puis cliquez sur dépôt',
		'Product Name': 'Bookmaker',
		'Amount': 'Montant',
		'fileValidation': 'Seulement jpg jpeg et png avec un maximum de 2MB',
		'Transaction Summary': 'Résumé des transactions',
		'Total amount to be deposited in your account': 'Montant total à déposer sur votre compte',
		'Total amount to be sent in your account': 'Montant total à envoyer sur votre compte',
		'You have submitted the BTC deposit request form.': 'Vous avez rempli le formulaire de dépôt en bitcoin.',
		'Please send the BTC amount to the BTC address below. This address is unique to your account.': 'Veuillez SVP envoyer le montant en BTC à l’adresse ci-dessous. Cette adresse est uniquement utilisée pour votre compte.',
		'Tap or Scan to pay': 'Toucher ou scanner pour payer',
		'Show QR': 'Montrer QR',
		'Total BTC to be sent': 'Montant total BTC à envoyer',
		'Recipient BTC Address': 'Adresse BTC du bénéficiaire',
		'Please send total BTC to the recipient address.': 'Veuillez SVP envoyer le montant total en BTC à l’adresse bénéficiaire',
		'Copy': 'Copie',
		'Rate Used per BTC': 'Taux par BTC',
		'Please send bitcoin in': 'Veuillez SVP envoyer vos bitcoin en',
		'minutes.': 'minutes.',
		'This page will automatically refresh when Bitcoin has been sent.': 'Cette page s’actualisera automatiquement une fois que les bitcoins auront été envoyés',
		'Thank you for sending the requested amount!': 'Merci de nous avoir envoyer le montant souhaité!',
		'We are now waiting for your Bitcoin confirmations.': 'Nous attendons désormais la confirmation de vos bitcoins',
		'confirmation(s) received': 'confirmation(s) reçues',
		'Status': 'Statut',
		'Thank you for making a deposit!': 'Merci d’avoir effectuer un dépôt!',
		'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.': 'Nous allons maintenant vérifier votre dépôt. Dès que nous aurons reçu votre dépôt, celui-ci apparaîtra sur votre compte',
		'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.': 'Nous attendons désormais de recevoir vos bitcoins. Cette page s’actualisera automatiquement une fois que les bitcoins auront été reçus.',
		'Requested: waiting to receive bitcoin': 'En attente de réception des bitcoins.',
		'Note: Please contact Support if you made a request by mistake and would like to request again': 'Note : Veuillez svp contacter le support client si vous avez effectué une requête par erreur et que vous souhaitez en effectuer une autre.',
		'bitcoinDeclined': "Nous sommes désolés, votre requête a été ANNULEE probablement car nous n'avons pas reçu vos bitcoins. Si c'est une erreur, merci de contacter le support client afin que nous vérifions cela avec vous.",
		'Close': 'Fermer',
		'Exchange Rate': 'Taux de change',
		'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.': 'Note : Le taux de change est mis à jour en temps réel. Ce taux sera arrêté et bloqué une fois que vous aurez soumis votre requête',
		'Total BTC amount to send:': 'Montant total BTC à envoyer:',
		'Total EUR amount to receive:': 'Montant total EUR à recevoir:',
		'Transaction Status': 'Statut transaction',
		'Requested': 'Demande formulée',
		'Pending Confirmation': 'Confirmation en attente',
		'Confirmed': 'Confirmé',
		'Declined': 'Refusé',
		'Voided': 'Annulé',
		'Account ID': 'ID compte',
		'Amount to deposit': 'Montant à déposer',
		'Total amount to deposit': 'Montant total à déposer',
		'Free': 'Gratuit',
		'Add product': 'Ajouter produit',
		'Make new request': 'Nouvelle requête',
		'we will send you the username and password of your newly registered account.': 'Nous vous enverrons le nom d’utilisateur et le mot de passe de votre compte nouvellement créé',
		'Total amount to be deposited on account': 'Montant total à déposer sur votre compte',
		'Total amount to be deducted from account': 'Montant total à déduire de votre compte',
		'Total amount to be sent': 'Montant total à envoyer',
		'Total amount to be received': 'Montant total à recevoir',
		'Enter product username': 'Entrer le nom d’utilisateur pour ce produit',
		'Total amount to send': 'Montant total à envoyer',
		'Request is successfully created!': 'La requête a été créée avec succès!',
		'Please wait for customer service confirmation. You can view transaction status in Transactions overview.': 'Veuillez SVP attendre la confirmation du service client. Vous pouvez voir le statut de la transaction dans le résumé des transactions.',
		'Unable to Transfer': 'Impossible d’effectuer le transfer',
		'Please contact our customer service team to have your account verified. Thank you.': 'Veuillez svp contacter notre service client afin de valider votre compte. Merci',
		'No product(s) available for selection.': 'Aucun produit disponible',
		'Opps, amount is not enough!': 'Le montant est trop faible!',
		'Minimum amount that can be withdrawn is 100 EUR/GBP.': 'Le montant minimum pouvant être retiré est de 100 EUR/GBP',
		'Do you want ': 'Voulez-vous vous ',
		'to be your default bank for withdrawal?': 'que ce soit votre banque par défaut pour les retraits?',
		'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.': 'Vous avez sélectionné le virement bancaire comme votre méthode de paiement préférée. Si vous voulez le modifier, veuillez svp cliquer sur le prochain onglet.',
		'Minimum Withdrawal Amount': 'Montant minimum de retrait',
		'Maximum Withdrawal Amount': 'Montant maximum de retrait',
		'Bank Account': 'Compte bancaire',
		'Link new bank account': 'Lier nouveau compte bancaire',
		'transactionPasswordHint': 'Pour mémoire : si vous êtes déjà client depuis mars 2017 et n’avez toujours pas paramétré votre mot de passe de transaction, celui-ci est la réponse à votre question de sécurité : « Quel est votre métier rêvé? »',
		'Beneficiary name': 'Nom du bénéficiaire',
		'Beneficiary address': 'Adresse du bénéficiaire',
		'IBAN': 'IBAN',
		'Bank name': 'Nom de la banque',
		'Bank address': 'Adresse de la banque',
		'SWIFT': 'SWIFT',
		'Total amount to be deducted from your account': 'Montant total à déduire de votre compte',
		'Total amount to be received in your account': 'Montant total à recevoir sur votre compte',
		'Confirmation Message': 'Message de confirmation',
		'Yes': 'Oui',
		'No': 'Non',
		'confirmations': 'confirmations',
		'Please select product(s) where you want to withdraw, and input the amount in': 'Veuillez SVP sélectionner le produit pour lequel vous souhaitez effectuer le retrait, et indiquer le montant',
		'or BTC': 'ou BTC',
		'Total BTC': 'Total BTC',
		'SEND TO': 'A ENVOYER SUR',
		'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.': 'Veuillez SVP vous assurer que votre adresse bitcoin est correcte. Nous enverrons vos BTC à cette adresse.',
		'Total BTC amount to receive': 'Montant total BTC à recevoir',
		'Total': 'Total',
		'amount to be deducted': 'Montant à déduire',
		'Amount to deduct': 'Montant à déduire',
		'Total amount to receive': 'Montant total à recevoir',
		'Opps, we need to know where to wire your funds.': 'Nous avons besoin de savoir où transférer les fonds',
		'Please fill in the required bank details. Thank you!': 'Veuillez svp remplir les données bancaires. Merci!',
		'Unable to withdraw': 'Impossible de retirer',
		'Invalid Action!': 'Action invalide!',
		'A product where the fee should be charged is required.': 'Un produit où les frais seront déduits est requis',
		'Reset link was sent to your email.': 'Le lien de ré-initialisation vient d’être envoyé sur votre adresse email',
		'Success!': 'Success!',
		'Send reset password link': 'Envoyer le lien de ré-initialisation du mot de passe',
		"Enter the email you use for Asianconnect88, and we'll help you create a new password.": "Entrer l'adresse email utilisée sur asianconnect88 et nous vous aiderons à créer un nouveau mot de passe",
		'English': 'Anglais',
		'French': 'Français',
		'German': 'Allemand',
		'Spanish': 'Espagnol',
		'Asian Odds': 'Asian Odds',
		'Note: Referral URL is your unique link where you can share to everyone': 'Note : votre URL d’affiliation est votre unique lien que vous pouvez partager à tout le monde',
		'Referral HTML Code': 'Referral HTML Code',
		'copyReferralCodeNote': 'Copiez ou téléchargez simplement le code HTML de votre campagne, et collez-le dans la section de votre site internet où vous souhaitez le voir apparaître',
		'Download HTML': 'Télécharger HTML',
		'Terms and Conditions': 'Conditions générales',
		'and': 'et',
		'Commission Scheme': 'Structure de commissions',
		'apply': 'appliquer',
		'Referral URL': 'URL affilié',
		'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.': 'Note : votre URL d’affiliation est votre unique lien que vous pouvez utiliser pour rediriger vos clients sur Asianconnect',
		'Information': 'Information',
		'Get a unique tracking link for your campaign.': 'Obtenez un lien unique d’affiliation pour votre campagne',
		'Website. Input your website URL.': 'Site internet, Indiquez l’URL de votre site internet',
		'Banner type. Pick a banner type: (language/size/promo)': 'Type de bannière. Choisissez un type de bannière: (langue/taille/promo)',
		'Campaign. Name your campaign.': 'Campagne. Nommez votre campagne',
		'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.': 'Tracking code. Vous avez un tracking code préféré ? Indiquez le. Cliquez sur générer.',
		'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.': 'Votre URL d’affiliation est un lien unique que vous pouvez utiliser pour rediriger vos clients sur Asianconnect',
		'campaignNote': 'Copiez ou téléchargez simplement le code HTML de votre campagne, et collez-le dans la section de votre site internet où vous souhaitez le voir apparaître',
		'Preview archived banner': 'Pré-visualiser les bannières archivées',
		'Uploaded': 'Télécharger',
		'Drag and drop files here or': 'Glissez et déposez vos fichiers ici ou',
		'Select file(s)': 'Sélectionnez fichier(s)',
		'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 2MB is allowed.': 'Seulement jpg jpeg docx doc pdf et png avec un maximum de 2MB',
		'file(s) selected. Click upload to proceed.': 'Fichier(s) sélectionnés. Cliquez sur upload pour procéder au chargement',
		'The file is too large (MB). Allowed maximum size is 2MB.': 'Le fichier est trop gros (MB). La taille maximum autorisée est 2MB.',
		'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.': 'Seulement jpg jpeg docx doc pdf et png sont autorisés',
		'Successfully uploaded!': 'Téléchargé avec succès!',
		'Documents uploaded': 'Documents téléchargés',
		'Delete Document': 'Supprimer document',
		'Are you sure you want to delete this document?': 'Êtes-vous sur de vouloir supprimer ce document?',
		'Cancel': 'Annuler',
		'Delete': 'Supprimer',
		'Account Information': 'Information de compte',
		'Customer ID': 'ID Client',
		'Full name': 'Nom complet',
		'Currency': 'Devise',
		'Country': 'Pays',
		'Date of birth': 'Date de naissance',
		'Join date': 'Date d’inscription',
		'Email Address': 'Adresse e-mail',
		'Phone number': 'Numéro de téléphone',
		'Skype': 'Skype',
		'Username': 'Nom d’utilisateur',
		'K.Y.C documents': 'K.Y.C documents',
		'Password changed.': 'Mot de passe modifié',
		'I want to request a new reset code.': 'Je veux obtenir un nouveau code de ré-initialisation',
		'Loading, please wait...': 'Chargement, merci de patienter...',
		'Request new reset code?': 'Obtenir un nouveau code de ré-initialisation?',
		'Enter your new account password below.': 'Entrez votre nouveau mot de passe ci-dessous',
		'Account password has been successfully updated!': 'Votre mot de passe a été mis à jour avec succès!',
		'Update AMS account password': 'Mettre à jour votre mot de passe de votre compte AMS',
		'Current AMS password': 'Mot de passe actuel',
		'New AMS Password': 'Nouveau mot de passe AMS',
		'Enter current password': 'Entrez votre mot de passe actuel',
		'Enter new password': 'Entrez votre nouveau mot de passe',
		'Confirm new password': 'Confirmez votre nouveau mot de passe',
		'Update': 'Mis à jour',
		'Are you sure you want to delete this Bank Account?': 'Êtes-vous sur de vouloir supprimer ce compte bancaire ?',
		'Add bank accounts for faster transaction.': 'Ajouter un compte bancaire pour des transactions plus rapides',
		'Default': 'Défaut',
		'Link a new bank account': 'Lier un nouveau compte bancaire',
		'Bank account successfully deleted.': 'Compte bancaire supprimé avec succès',
		'Success': 'Succès',
		'Transaction password has been successfully updated!': 'Le mot de passe de transaction a été mis à jour avec succès',
		'Update AMS transaction password': 'Mettre à jour votre mot de passe de transaction AMS',
		'Current AMS transaction password': 'Mot de passe de transaction AMS actuel',
		'Enter current transaction password': 'Entrez votre mot de passe de transaction AMS actuel',
		'New AMS transaction password': 'Nouveau mot de passe de transaction AMS',
		'Enter new transaction password': 'Entrez votre nouveau mot de passe de transaction',
		'Confirm new transaction password': 'Confirmez le nouveau mot de passe de transaction',
		'Account username has been successfully updated!': 'Le nom d’utilisateur a été mis à jour avec succès',
		'Update AMS username': 'Mettre à jour votre nom d’utilisateur',
		'Current AMS username': 'Nom d’utilisateur actuel',
		'New AMS username': 'Nouveau nom d’utilisateur',
		'Enter new username': 'Entrez votre nouveau nom d’utilisateur',
		'Confirm new username': 'Confirmez votre nouveau nom d’utilisateur',
		'Enter password': 'Entrez mot de passe',
		'Security': 'Sécurité',
		'Update your Username, Account and Transaction Password': 'Mettre à jour votre nom d’utilisateur et votre mot de passe de transaction',
		'Temporarily Unavailable': 'Temporairement indisponibles',
		'For inquiries, please contact Customer Support.': 'Pour toute question, merci de contacter le service client',
		'Payment Option': 'Option de paiement',
		'Manage your payment accounts': 'Gérer vos comptes de paiement',
		'Open': 'Ouvert',
		'Pending': 'En cours',
		'Resolved': 'Résolu',
		'Closed': 'Clôturé',
		'Forbidden!': 'Interdit!',
		'My Products': 'Mes produits',
		'Add Product': 'Ajouter produits',
		'Reset Product Password': 'Ré-initialiser mot de passe du produit',
		'New': 'Nouveau',
		'Bank account successfully created.': 'Compte bancaire créé avec succès',
		'Link a bank account': 'Lier un compte bancaire',
		'Enter Account Number': 'Entrer le numéro de compte',
		'Enter Account Name': 'Entrer le nom du compte',
		'Enter Citizenship': 'Entrer nationalité',
		'Enter Address': 'Entrer adresse',
		'Enter Bank Code': 'Entrer code banque',
		'Enter Bank Name': 'Entrer nom de la banque',
		'Enter Bank Address': 'Entrer l’adresse de la banque',
		'Save bank account': 'Sauvegarder compte bancaire',
		'Save': 'Sauvegarder',
		'Limit Reached!': 'Limite atteinte!',
		'Go to Settings': 'Allez aux paramètres',
		'Product password successfully requested.': 'Mot de passe produit demandé avec succès',
		'Warning': 'Attention',
		'Something went wrong. Please try again later.': 'Une erreur s’est produite. Merci de ré-essayer plus tard',
		'Request Product Password': 'Demander mot de passe du produit',
		'Select one or more products to reset password': 'Sélectionnez un ou plusieurs produits à ré-initialiser le mot de passe',
		'View Password': 'Voir le mot de passe',
		'Expires on': 'Expire au',
		'Expired Password': 'Mot de passe expiré',
		'No Password': 'Pas de mot de passe',
		'Enter Transaction Password': 'Entrez mot de passe de transaction',
		'Request': 'Demande',
		'Product password will be available once password has been reset.': 'Le mot de passe du produit sera disponible une fois que le mot de passe aura été ré-initialisé',
		'Warning!': 'Attention!',
		'Warning! The following product/s has pending request': 'Attention! Le produit suivant a une demande en attente',
		'Request Product': 'Demander produit',
		'Please select at least one product below': 'Veuillez SVP choisir au moins un produit ci-dessous',
		'No products available. You already have all the products Asianconnect offers.': 'Aucun produit disponible, vous avez déjà tous les produits proposés par Asianconnect',
		'username': 'Nom d’utilisateur',
		'SINGBET FORCED POSITION TAKING ON ASIANCONNECT': 'SINGBET OBLIGE ASIANCONNECT A PRENDRE POSITION SUR LES PARIS',
		'Profit and Loss (PnL)': 'Gain et perte (GnP)',
		'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.': 'Veuillez SVP noter que votre gain/perte sur SINGBET est toujours GnP*0,40',
		'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).': 'Donc si votre mise est de 1000 et que vous gagnez, vous gagnez seulement 400 EUR/GBP (1000*0,40)',
		'Then if you lose, you only lose 400 EUR/GBP.': 'Et si vous perdez, vous perdez seulement 400 EUR/GBP',
		'Deposits': 'Dépôts',
		'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.': 'Votre dépôt sur SINGBET est toujours montant / 0,40. Cela signifie que si vous envoyez 1000 EUR/GBP, nous ajouterons 2500 (1000/0,40=2500) à votre balance SINGBET',
		'Withdrawals': 'Retraits',
		'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.': 'Également, votre retrait sera de /0,40. Cela signifie que si vous souhaitez retirer 1000 EUR/GBP, nous déduirons 2500 (1000/0,40) de votre balance SINGBET',
		'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.': 'Dans votre compte AMS apparaîtra votre solde réel en EUR/GBP, cependant dans votre compte SINGBET cela sera le solde SINGBET',
		'I agree to the Terms and Conditions': 'J’accepte les conditions générales',
		'MAXBET FORCED POSITION TAKING ON ASIANCONNECT': 'MAXBET OBLIGE ASIANCONNECT A PRENDRE POSITION SUR LES PARIS',
		'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.': 'Veuillez SVP noter que votre gain/perte sur MAXBET est toujours GnP*0,50.',
		'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).': 'Donc si votre mise est de 1000 et que vous gagnez, vous gagnez seulement 500 EUR/GBP (1000*0,50).',
		'Then if you lose, you only lose 500 EUR/GBP.': 'Et si vous perdez, vous perdez seulement 500 EUR/GBP.',
		'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.': 'Votre dépôt sur MAXBET est toujours montant / 0,50. Cela signifie que si vous envoyez 1000 EUR/GBP, nous ajouterons 2000 (1000/0,50=2000) à votre balance MAXBET',
		'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.': 'Également, votre retrait sera de /0,50. Cela signifie que si vous souhaitez retirer 1000 EUR/GBP, nous déduirons 2000 (1000/0,50) de votre balance MAXBET',
		'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.': 'Dans votre compte AMS apparaîtra votre solde réel en EUR/GBP, cependant dans votre compte MAXBET cela sera le solde MAXBET',
		'SBOBET Forced Position Taking ON ASIANCONNECT': 'SBOBET OBLIGE ASIANCONNECT A PRENDRE POSITION SUR LES PARIS',
		'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.': 'Veuillez SVP noter que votre gain/perte sur SBOBET est toujours GnP*0,30. Donc si votre mise est de 1000 et que vous gagnez, vous gagnez seulement 300 EUR/GBP (1000*0,30). Et si vous perdez, vous perdez seulement 300 EUR/GBP.',
		'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Votre dépôt sur SBOBET est toujours montant / 0,30. Cela signifie que si vous envoyez 1000 EUR/GBP, nous ajouterons 3333,33 (1000/0,30=3333,33) à votre balance SBOBET',
		'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Également, votre retrait sera de /0,30. Cela signifie que si vous souhaitez retirer 1000 EUR/GBP, nous déduirons 3333,33 (1000/0,30) de votre balance SBOBET',
		'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.': 'Dans votre compte AMS apparaîtra votre solde réel en EUR/GBP, cependant dans votre compte SBOBET cela sera le solde SBOBET',
		'9WICKETS FORCED POSITION TAKING ON ASIANCONNECT': '9WICKETS OBLIGE ASIANCONNECT A PRENDRE POSITION SUR LES PARIS',
		'Please note that 9wickets have 3% commission rate applied to your winnings.': 'Veuillez SVP noter que 9wickets applique une commission de 3% sur l’ensemble de vos gains',
		'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.': 'Veuillez également noter que 9Wickets effectue un contrôle quotidien de tous les paris placés sur leur plateforme. S’ils s’aperçoivent d’une quelconque irrégularité ou fraude, ils se réservent le droit de clôturer votre compte et de garder vos fonds.',
		'ORBITX FORCED POSITION TAKING ON ASIANCONNECT': 'ORBITX OBLIGE ASIANCONNECT A PRENDRE POSITION SUR LES PARIS',
		'Please note that OrbitX have 3% commission rate applied to your winnings.': 'Veuillez SVP noter que ORBITX applique une commission de 3% sur l’ensemble de vos gains',
		'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.': 'Veuillez également noter que ORBITX effectue un contrôle quotidien de tous les paris placés sur leur plateforme. S’ils s’aperçoivent d’une quelconque irrégularité ou fraude, ils se réservent le droit de clôturer votre compte et de garder vos fonds.',
		'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT': 'Conditions générales pour les paris via SKYPE',
		'You can contact us via Skype at': 'Vous pouvez nous contacter via skype à',
		'NV for Skype betting Terms and Conditions.': 'Conditions générales pour les paris via skype',
		'Successfully added!': 'Ajouté avec succès!',
		'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.': 'Le(s) produit(s) suivant(s) a été ajouté. Vous pouvez désormais effectuer un dépôt sur votre compte. Vous recevrez votre nom d’utilisateur et votre mot de passe aussitôt après que nous ayons reçu votre premier dépôt. Merci',
		'About Us': 'A propos de nous',
		'Contact Us': 'Contactez-nous',
		'Legal Disclaimer': 'Avertissement légal',
		'Privacy Policy': 'Politique de confidentialité',
		'Go To Transaction Overview': 'Allez au résumé des transactions',
		'Notification': 'Notification',
		'was deleted.': 'a été supprimé.',
		'Failed to delete': 'Impossible de supprimer',
		'file has been uploaded.': 'Le fichier a été téléchargé',
		'Failed to upload': 'Impossible de télécharger',
		'Paste an address where you want to receive BTC': 'Collez l’adresse sur laquelle vous souhaitez recevoir vos bitcoins',
		'New referral': 'Nouvel affilié',
	    'has been linked.': 'a été lié.',
	    'Referral': 'Affilié',
	    'has been unlinked.': 'a été annulé.',
	    'Product/s': 'Produit/s',
	    'has been added.': 'a été ajouté.',
	    'Transaction': 'Transaction',
	    'has been': 'a été',
	    'Deposit': 'Dépôt',
	    'Withdraw': 'Retrait',
	    'Transfer': 'Transfert',
	    'P2P Transfer': 'Transfert P2P',
	    'Approved': 'Approuvé',
	    'Acknowledged': 'Pris en compte',
	    'Processed': 'Effectué',
	    'Saved': 'Sauvegardé',
	    'Invalid Credentials!': 'Les informations d’identification invalides!',
		'Email': 'E-mail',
		'Account ID': 'ID compte',
		'Name': 'Nom',
		'Request Deposit': 'Demande de dépôt',
		'Request Withdrawal': 'Demande de retrait',
		'Upload': 'Télécharger',
		'W/L': 'W/L',
	    'Bonus': 'Prime',
	    'Revenue Share': 'Partage des revenus',
        'Total W/L:': 'Total W/L:',
	    'Total Bonus:': 'Bonus total:',
	    'Total Revenue Share:': 'Partage total des revenus:',
		'Unlimited': 'Illimité',
		'Instant': 'Instantané',
		'My Tickets': 'Mes tickets',
		'Product is required': 'Un produit est requis',
		'Transaction password invalid': 'Mot de passe de transaction invalide',
		'Transaction deposit has been saved': 'La demande de dépôt a été sauvegardée',
		'Product has been added': 'Le produit a été ajouté',
		'Transaction withdrawal has been saved': 'La demande de retrait a été sauvegardée',
		'Transaction transfer has been saved': 'La demande de transfert a été sauvegardée',
		'Transaction deposit has been declined': 'La demande de dépôt a été refusée',
		'Transaction withdrawal has been declined': 'La demande de retrait a été refusée',
		'Transaction transfer has been declined': 'La demande de transfert a été refusée',
		'Transaction deposit has been voided': 'La demande de dépôt a été annulée',
		'Transaction withdrawal has been voided': 'La demande de retrait a été annulée',
		'Transaction transfer has been voided': 'La demande de transfert a été annulée',
		'Documents uploaded:': 'Documents téléchargés:',
		'Warning! At least one product is required.': 'Attention! Au moins un produit est requis',
		'paymentOptionsViewDetails': 'Important : Après avoir effectué un dépôt, veuillez svp remplir ce champ. Si cela n’est pas effectué, votre dépôt sera retardé. Cette procédure est nécessaire afin de nous informer de votre dépôt pour que nous puissions l’ajouter sur votre compte.',
		'File(s) still uploading, please wait.': 'Fichier (s) en cours de téléchargement, veuillez patienter.',
		'DEPOSIT': 'DÉPÔT',
	    'WITHDRAWAL': 'RETRAIT',
	    'TRANSFER': 'TRANSFERT',
	    'BONUS': 'PRIME',
	    'PSP TRANSFER': 'PART DES REVENUS',
	    'COMMISSION': 'COMMISSIONS',
	    'DEBIT': 'DÉBIT',
	    'CREDIT': 'CRÉDIT',
	    'REVENUE SHARE': 'PART DES REVENUS',
		'RESET BOOKIE PASSWORD': 'Réinitialiser mot de passe de bookmaker',
		'Ecopayz Merchant Account (EUR)': 'Compte marchand Ecopayz (EUR)',
	}
}


// WEBPACK FOOTER //
// ./client/app/shared/locales/locale-fr.js